<wl-content-section [id]="id()" [theme]="theme()">
  <wl-generic-products-section
    [title]="title()!"
    [content]="content()!"
    [rendering]="rendering()"
  />
</wl-content-section>
